(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aliuor-product-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aliuor-product-grid')) {
  customElements.define('aliuor-product-grid', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      if (this.dataset.animation === 'none' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('apg--revealing');
            if (this.dataset.once === 'true') this.observer.unobserve(entry.target);
          } else if (this.dataset.once !== 'true') {
            entry.target.classList.remove('apg--revealing');
          }
        });
      }, { threshold: 0.05 });
      this.querySelectorAll('.apg__item').forEach(item => this.observer.observe(item));
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
